import { MARQUEE_ITEMS } from "@/data/content";

const Marquee = () => (
  <div
    data-testid="marquee-ticker"
    className="relative overflow-hidden border-y border-[#27272A] bg-[#0c0c0e] py-5"
  >
    <div className="animate-marquee flex w-max items-center whitespace-nowrap">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex items-center" aria-hidden={dup === 1}>
          {MARQUEE_ITEMS.map((item) => (
            <span key={`${dup}-${item}`} className="flex items-center">
              <span className="font-syne text-lg font-bold uppercase tracking-[0.12em] text-zinc-500 sm:text-xl">
                {item}
              </span>
              <span className="px-8 text-sm text-[#CC0A14]">◆</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default Marquee;
